/* AFS7 - het winkelmandje schuift in beeld in plaats van een paginasprong.
   Desktop van rechts over een gedimde pagina, mobiel volledig scherm van onderen.

   Waarom de bestaande cart hergebruiken
   -------------------------------------
   We bouwen GEEN tweede winkelmandje. De lade haalt de echte cartpagina op en
   zet de hele sectie erin: de ladder naar gratis verzending, de gratis-cadeauregel,
   de cross-sells, de trust-regels en de samenvatting. Een tweede versie zou binnen
   een week uit de pas lopen met de eerste.

   Zes dingen die hierbij misgaan als je ze niet regelt
   ----------------------------------------------------
   1. De cartpagina verbergt de footer met
      <style>.shopify-section-group-footer-group{display:none}</style>.
      Die stijl zit IN de sectie, reist dus mee, en zou de footer op de home page
      slopen. We halen elk style-blok met footer-group eruit, en niet alleen bij
      het eerste laden: ook na elke verversing, want dan komt hij opnieuw mee.
   2. Scripts in HTML die via innerHTML binnenkomt draaien niet, dus de eigen
      knoppen-JS van de cartsectie doet hier niets. afs7-cartfix.js vangt de
      knoppen binnen de lade af op documentniveau.
   3. Die knoppen moeten wel eerst een lijnsleutel krijgen. Daarom roepen we na
      elk inladen 'afs7:drawer-filled' af, waar cartfix op stempelt. Zonder die
      seinregel staan de knoppen er wel maar doen ze niets.
   4. Luister NIET op 'afs2:cart-updated' om opnieuw te laden: cartfix roept dat
      zelf af na een wijziging, en dan laadt de lade zichzelf eindeloos opnieuw.
      Na een wijziging vervangt cartfix de sectie al ter plekke.
   5. De sectie-CSS is gescoped op het sectie-id (#shopify-section-... .afs2k).
      Daarom verplaatsen we het HELE sectie-element en niet alleen de binnenkant,
      anders valt de opmaak weg.
   6. Een <script src> die via innerHTML binnenkomt draait EVENMIN. De balk naar
      gratis verzending en de bedragen worden gevuld door assets/afs2-amt.js, en
      die stond dus stil: de balk bleef op width:0% staan ook al was de drempel
      allang gehaald. Dat bestand laden we nu gewoon als los script op de pagina
      (zie sections/afs7-assets.liquid) en hier roepen we alleen zijn
      window.afs2Refresh() aan. Niets nabouwen: die code kent de drempels, de
      valuta en de opmaak van bedragen al.

   De lade wordt al bij het laden gevuld, zodat de stijl van de cart binnen is
   voordat iemand hem opent en er geen ongestileerde flits is. */
(function () {
  'use strict';
  if (window.__afs7Drawer) return;
  window.__afs7Drawer = true;

  var CFG = window.__afs7DrawerText || {};
  var root, body, lastFocus, loaded = false, busy = false;

  function build() {
    root = document.createElement('div');
    root.className = 'afs7-dw';
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML =
      '<div class="afs7-dw__veil" data-afs7-dw-close></div>' +
      '<aside class="afs7-dw__panel" role="dialog" aria-modal="true" aria-label="' +
        (CFG.title || 'Your cart') + '">' +
        '<header class="afs7-dw__head">' +
          '<span class="afs7-dw__t">' + (CFG.title || 'Your cart') + '</span>' +
          '<button type="button" class="afs7-dw__x" data-afs7-dw-close aria-label="' +
            (CFG.close || 'Close') + '">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
          '</button>' +
        '</header>' +
        '<div class="afs7-dw__body" data-afs7-dw-body></div>' +
      '</aside>';
    document.body.appendChild(root);
    body = root.querySelector('[data-afs7-dw-body]');

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-afs7-dw-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });
  }

  /* De footer-verberger van de cartpagina mag nooit buiten de cartpagina landen. */
  function stripFooterStyle(scope) {
    if (!scope) return;
    var st = scope.querySelectorAll('style');
    for (var i = 0; i < st.length; i++) {
      if (/footer-group/.test(st[i].textContent)) st[i].remove();
    }
  }
  window.afs7DrawerStrip = function () { stripFooterStyle(body); };

  /* De balk en de bedragen laten vullen door de eigen code van het thema. */
  function refreshAmounts() {
    if (window.afs2Refresh) { try { window.afs2Refresh(); } catch (e) {} }
  }

  function load() {
    if (busy) return Promise.resolve(false);
    busy = true;
    return fetch('/cart', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var box = document.createElement('div');
        box.innerHTML = html;
        var wrap = box.querySelector('[data-afs2k]');
        if (!wrap) return false;
        var sec = wrap.closest('[id^="shopify-section"]') || wrap;
        body.innerHTML = '';
        body.appendChild(sec);
        stripFooterStyle(body);
        loaded = true;
        refreshAmounts();
        // Seinregel voor cartfix: stempel de knoppen met hun lijnsleutel.
        document.dispatchEvent(new CustomEvent('afs7:drawer-filled'));
        return true;
      })
      .catch(function () { return false; })
      .then(function (ok) { busy = false; return ok; });
  }

  function open() {
    if (!root) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('afs7-dw-lock');
    if (!loaded) load(); else refreshAmounts();
    var x = root.querySelector('.afs7-dw__x');
    if (x) setTimeout(function () { x.focus(); }, 60);
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('afs7-dw-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* Het mandje in de header opent de lade in plaats van te navigeren.
     Met cmd, ctrl of shift, of een andere muisknop, gewoon de link volgen. */
  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    var a = e.target.closest && e.target.closest('a[href$="/cart"], a.header__icon--cart');
    if (!a) return;
    if (a.closest('.afs7-dw')) return; // links binnen de lade zelf met rust laten
    e.preventDefault();
    open();
    load();
  });

  document.addEventListener('afs7:cart-added', function () {
    load().then(function () { if (CFG.openOnAdd) open(); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build, { once: true });
  } else { build(); }

  var prime = function () { if (root && !loaded) load(); };
  if ('requestIdleCallback' in window) { requestIdleCallback(prime, { timeout: 4000 }); }
  else { setTimeout(prime, 2500); }
})();